import { camelCase, omit } from 'lodash-es';

import { IFavouriteReportFromServer } from 'src/app/standaloneSlices/commonModels';
import { IMenuItem, IMenuItemFromServer, IReportItem } from 'src/feature/Menu/menuModels';
import { defaultComparator } from './comparator';

export const searchMenu = (allMenus: IReportItem[], searchKey?: string) => {
  if (searchKey && allMenus) {
    const temp: Record<number | string, IReportItem[]> = {};
    allMenus.forEach((report) => {
      const regexp = new RegExp(camelCase(searchKey), 'i');
      const matchResult = camelCase(report.Title || '').match(regexp);
      if (matchResult) {
        const index = matchResult.index!;
        if (!temp[index]) {
          temp[index] = [report];
        } else {
          temp[index].push(report);
        }
      }
    });

    const result = Object.keys(temp).reduce((obj, key) => {
      obj.push(...temp[key]);
      return obj;
    }, [] as IReportItem[]);

    return result;
  }
  return [];
};
export function findMenuItemByMenuName(menuItems: IMenuItem[], menuName: string): IMenuItem {
  let searchResult: IMenuItem = { Name: '' };
  const doSearch = (menuItems: IMenuItem[]) => {
    menuItems.forEach((item) => {
      if (
        camelCase(item?.Name?.toLowerCase()).includes(camelCase(menuName.toLowerCase())) ||
        (item?.MenuTitle && camelCase(item?.MenuTitle?.toLowerCase()))?.includes(camelCase(menuName.toLowerCase()))
      ) {
        searchResult = item;
        return;
      }
      if (item.SubMenuItems && item.SubMenuItems.length > 0) {
        doSearch(item.SubMenuItems);
      }
    });
  };
  doSearch(menuItems);
  return searchResult;
}

export const getCurrentPathNodes: (item: IMenuItem) => IMenuItem[] = (item: IMenuItem) => {
  if (!item) {
    return [];
  }
  const path: IMenuItem[] = [item];
  let currentNode = item;
  while (currentNode.ParentNode !== null && currentNode.ParentNode !== undefined) {
    path.push(currentNode.ParentNode);
    currentNode = currentNode.ParentNode;
  }
  path.reverse();
  return path;
};
const _getCurrentPath: (path: IMenuItem[]) => string = (path: IMenuItem[]) => {
  const pathFromRootToCurrentMenuItem = `/${path.map((i) => camelCase(i.Name!)).join('/')}`;
  return pathFromRootToCurrentMenuItem;
};

export function isDirectory(menuItem: IMenuItem): boolean {
  return !!(menuItem?.SubMenuItems && menuItem?.SubMenuItems?.length >= 1);
}

export function getPathOfMenuItem(menuItem: IMenuItem) {
  const pathNodes = getCurrentPathNodes(menuItem);
  return _getCurrentPath([...pathNodes]);
}

export function calcItemLevel(item: IMenuItem) {
  let level = 0;
  let traverse = item;
  while (traverse.ParentNode) {
    level++;
    traverse = traverse.ParentNode;
  }
  return level;
}

export const processMenuList = (nodes: IMenuItemFromServer[], parent: IMenuItemFromServer | null) => {
  nodes.forEach((node) => {
    if (node.MenuItems) {
      node.SubMenuItems = (node.SubMenuItems || []).concat(node.MenuItems);
      delete node.MenuItems;
    }
    if (parent) {
      // remove circular structure
      node.ParentNode = omit(parent, 'SubMenuItems') as IMenuItem;
    }

    if (node?.SubMenuItems && node?.SubMenuItems?.length > 0) {
      processMenuList(node.SubMenuItems, node);
    } else {
      node.Path = getPathOfMenuItem(node);
    }
  });
};
export const sortMenus = (nodes: IMenuItem[]) => {
  nodes.forEach((node) => {
    if (node.SubMenuItems) {
      const subcategoryList = node.SubMenuItems.filter((item) => item.SubMenuItems)?.sort((menu1, menu2) => {
        return defaultComparator(menu1.Title, menu2.Title);
      });
      if (subcategoryList?.length) {
        sortMenus(subcategoryList);
      }
      const menuWithoutCategoryList = node.SubMenuItems.filter((item) => !item.SubMenuItems)?.sort((menu1, menu2) => {
        return defaultComparator(menu1.Title, menu2.Title);
      });
      node.SubMenuItems = [...subcategoryList, ...menuWithoutCategoryList];
    }
  });
  return nodes;
};
export const flatMenus = (nodes: IMenuItem[]) => {
  const temp: IReportItem[] = [];
  nodes.forEach((node) => {
    if (node.SubMenuItems) {
      temp.push(...flatMenus(node.SubMenuItems));
    } else {
      temp.push(node);
    }
  });

  return temp;
};

export function addFavouriteToMenu(menu: IMenuItem[], favouritereports: IFavouriteReportFromServer[]) {
  menu.forEach((node) => {
    if (node?.SubMenuItems && node?.SubMenuItems?.length > 0) {
      addFavouriteToMenu(node.SubMenuItems, favouritereports);
    } else {
      node.IsFavourite = !!favouritereports.find((item) => item.ReportName === node.Name);
    }
  });
}

export function getRootTitle(item: IReportItem) {
  let temp = item;
  while (temp.ParentNode) {
    temp = temp.ParentNode;
  }
  return temp.Title;
}
